var _title, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconUtensils = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  className: "icon icon--utensils",
  viewBox: "0 0 130 160",
  width: 24,
  height: 24,
  ref: svgRef
}, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "Utensils icon")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M40,40H30V0H20V40H10V0H0V55A25,25,0,0,0,20,79.49V160H30V79.49A25,25,0,0,0,50,55V0H40ZM25,70A15,15,0,0,1,10,55V50H40v5A15,15,0,0,1,25,70Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M130,40c0-22.06-13.46-40-30-40S70,17.94,70,40c0,19.78,10.83,36.21,25,39.4V160h10V79.4C119.17,76.21,130,59.78,130,40ZM100,70C89.16,70,80,56.26,80,40s9.16-30,20-30,20,13.74,20,30S110.84,70,100,70Z"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconUtensils, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/IconUtensils.3e55d77b.svg";
export { ForwardRef as ReactComponent };